module.exports = __webpack_public_path__ + "img/logotype_warex@3x.436f2ca.png";